import { LevelBuilder } from './LevelBuilder';
import { TileType } from '../TileEditorTypes';

/**
 * Procedurally generates an Editor + Mechanics Tutorial Map.
 * Demonstrates platforms, hazards, climbing, and entities.
 */
export function generateTutorialMap(): ReturnType<typeof LevelBuilder.prototype.build> {
  const level = LevelBuilder.create('tutorial_map', 100, 50)
    .setName('Sandbox Tutorial')
    .setBackground('#87CEEB');

  // Ground floor
  level.ground(0, 48, 100);

  // Safe starting zone
  level.spawn(5, 47);
  level.npcSpawn(8, 47, 'training_dummy'); // Something to hit right away

  // SECTION 1: Platforming & Jump Heights
  // Shows the difference between standard and bouncy platforms
  level.platform(15, 44, 4, TileType.WOOD);
  level.platform(21, 40, 4, TileType.STONE);
  level.platform(27, 35, 4, TileType.ICE); // Slippery jump

  // A high ledge that requires a bouncy pad to reach
  level.platform(35, 25, 10, TileType.STONE);
  level.tile(31, 47, TileType.HALF_WALL); // Bouncy pad on the floor (HALF_WALL maps to 'bouncy')

  // SECTION 2: Hazards & Ropes
  // A pit of lava that must be crossed using a rope
  level.ground(45, 48, 5); // Safe island
  level.lava(50, 48, 10, 2); // 10-wide lava pit
  level.ground(60, 48, 5); // Safe island

  // Climbable rope over the lava
  level.rope(55, 30, 18); // Hangs down from y=30 to y=48
  level.platform(53, 29, 5, TileType.WOOD); // Anchor platform for the rope

  // SECTION 3: Entities & Combat Sandbox
  level.wall(65, 30, 18); // A wall to block the combat arena

  // Arena floor
  level.ground(66, 48, 30, TileType.STONE);

  // Spawns some mobs to practice combat
  level.mobSpawn(75, 47, 'slime');
  level.mobSpawn(80, 47, 'slime');
  level.mobSpawn(85, 47, 'pig');

  // Some floating platforms in the arena for aerial combat testing
  level.platform(70, 40, 6, TileType.WOOD);
  level.platform(82, 35, 6, TileType.WOOD);

  // SECTION 4: Exit
  level.platform(95, 30, 3, TileType.STONE);
  level.teleporter(96, 29, 'starter_map');

  return level.build();
}
